import * as React from 'react'
import {Tooltip as TooltipPrimitive} from 'radix-ui'

import {cn} from '@/lib/utils'

const TooltipProvider = TooltipPrimitive.Provider
const Tooltip = TooltipPrimitive.Root
const TooltipTrigger = TooltipPrimitive.Trigger

function TooltipContent({className, sideOffset = 6, ...props}: React.ComponentProps<typeof TooltipPrimitive.Content>) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn(
          // Claro a propósito: los chips de tono semántico del detalle serían ilegibles sobre fondo oscuro.
          'z-50 max-w-[16rem] rounded-md border border-border bg-popover px-2.5 py-1.5 text-xs text-popover-foreground shadow-[var(--shadow-pop)] outline-none',
          className
        )}
        {...props}
      />
    </TooltipPrimitive.Portal>
  )
}

export {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger}
